<ng-container *ngIf="backendIsExistent && !isIE">
  <app-centered-loading-indicator *ngIf="!backendUserExists; else withBackendUser"></app-centered-loading-indicator>

  <ng-template #withBackendUser>

      <ng-container *ngIf="testLoaded">
        <app-nav></app-nav>
        <div class="content-container">
          <div class="content-area">
            <router-outlet></router-outlet>
            <app-invited-by-partner *ngIf="currentUser.hasPartner()"></app-invited-by-partner>
          </div>
        </div>
        <app-pwa></app-pwa>
      </ng-container>


    <!-- Checking for new versions of the application... -->
    <app-update></app-update>

  </ng-template>
</ng-container>

<div *ngIf="isIE">
  <app-internet-explorer></app-internet-explorer>
</div>

<div *ngIf="!backendIsExistent && !isIE">
  <app-service-unavailable></app-service-unavailable>
</div>

<id37-modal [(modalOpen)]="showOrderErrorModal" modalSize="normal">
  <id37-modal-title>
    <h4>{{__('OrderErrorModalTextHeadline')}}</h4>
  </id37-modal-title>

  <id37-modal-body>
    <div class="error-modal-content">
      <p>{{__('OrderErrorModalTextBody')}}</p>
    </div>
  </id37-modal-body>

  <id37-modal-footer>
    <button class="id37-btn-primary id37-btn-rounded-1" (click)="goToOrders()">
      {{__('OrderErrorModalTextLinkMessage')}}
    </button>
  </id37-modal-footer>
</id37-modal>
